<template>
  <default-layout class="not-found-page">
    <div class="centered">
      <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>404</h1>
      <p>The page you requested could not be found.</p>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '../Layout/Default'

export default {
  components: {
    DefaultLayout,
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/GeneralViews/NotFoundPage.vue